/* eslint-disable camelcase */
/****
 *
 * window & process.env constants
 *
 */
export const ELOQUENT = window.Eloquent;
export const AXIOS = window._axios;

// see https://github.com/SchwSimon/creatella-react-components#withasynccaller
window._withAsyncCallerAxios = window._BaseAxios;

export const APP_ENV = process.env.REACT_APP_ENV;
export const APP_URL = process.env.REACT_APP_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const APP_ROUTER_BASENAME = process.env.PUBLIC_URL;
export const GTM_KEY = process.env.REACT_APP_GTM_KEY;

/****
 *
 * Storage keys
 *
 */
export const STORAGEKEY_AUTH_TOKEN = 'sk-authToken';
export const STORAGEKEY_APP_LANGUAGE = 'sk-appLanguage';

/****
 *
 * Configs
 *
 */
// App default language (also used for the <html /> lang='' attribute)
// see https://developer.paciellogroup.com/blog/2016/06/using-the-html-lang-attribute/
// NOTE: make sure the language key defined here matches the default helmet key
// // see `executors/i18n/helmet`
export const APP_LANGUAGE_DEFAULT = 'en';

// App environments
// see .env.production & .env.development
// values must match the values defined in these files
export const APP_ENVS = {
    LOCAL: 'local',
    STAGING: 'staging',
    PRODUCTION: 'production'
};

// SENTRY - see https://docs.sentry.io/error-reporting/configuration/?platform=javascript
export const SENTRY_CONFIG = {
    environment: APP_ENV,
    dsn: ''
};

export const WEBFONT_CONFIG = {
    google: {
        families: [
            'Heebo',
            'Montserrat:100,300,400,600,800',
            'Open Sans:100,300,400,600,800',
            'Roboto:100,300,400,600,800'
        ]
    }
};

// Social networks config
export const SOCIAL_NETWORK_URLS = {
    FACEBOOK: 'https://www.facebook.com/PrismMedicalUK',
    INSTAGRAM: '',
    TWITTER: 'https://twitter.com/PrismMedicalUK',
    LINKEDIN: 'https://www.linkedin.com/company/prism-medical-uk',
    GOOGLEPLUS: '',
    EMAIL: '',
    YOUTUBE: 'https://www.youtube.com/channel/UCo3Wa1a2E7gVDrFZaqzdD3A'
};

export const FACEBOOK_APP_ID = '2376926962536672';

/****
 *
 * App routing
 *
 */
export const ROUTES = {
    HOME: '/product',
    ADMINPANEL: '/adminpanel',
    LOGIN: '/adminpanel/login',
    RECOVER_PASSWORD: '/adminpanel/recover-password',
    SET_NEW_PASSWORD: '/adminpanel/reset-password',
    DASHBOARD: '/adminpanel/dashboard',
    PRODUCT: '/adminpanel/product',
    USERS: '/adminpanel/users',
    EDITOR: '/adminpanel/editor',
    PROFILE: '/adminpanel/profile',
    NOTIFICATIONS: '/adminpanel/notifications',
    PRODUCT_DETAIL: (id = ':id') => `/adminpanel/product/detail/${id}`,
    PRODUCT_EDIT: (id = ':id') => `/adminpanel/product/edit/${id}`,
    PRODUCT_NEW: '/adminpanel/product/new',
    PRODUCT_VARIANT_DETAIL: (product_id = ':product_id', id = ':id') => `/adminpanel/product/${product_id}/variant/detail/${id}`,
    PRODUCT_VARIANT_EDIT: (product_id = ':product_id', id = ':id') => `/adminpanel/product/${product_id}/variant/edit/${id}`,
    PRODUCT_VARIANT_NEW: (product_id = ':product_id') => `/adminpanel/product/${product_id}/variant/new`,
    TRAINING_VIDEOS: '/adminpanel/training-videos',
    TRAINING_VIDEO_DETAILS: '/adminpanel/training-video-details',
    PUBLICPRODUCT: (slug = ':slug') => `/product/${slug}`,
    SUBCATEGORY: (id = ':id') => `/adminpanel/subCategory/${id}`,
    NOTFOUND: '/product/not-found',
    CONFIGURATION: (slug = ':slug') => `/product/configuration/${slug}`,
    VARIATION: (id = ':id', name = ':name') => `/product/${name}/variation/${id}`,
    SELECTED_ROOM: (name = ':name') => `/product/room/${name}`,
    CATEGORY_DETAILS: (name = ':name') => `/product/category-details/${name}`,
    SEARCH: (parameter = '') => `/product/search/${parameter}`,
    TAG: (parameter = ':parameter') => `/product/tag/${parameter}`,
    EMAIL_VERIFICATION: '/email-verification'
};

export const ROUTE_REDIRECT_AFTER_REGISTRATION = ROUTES.DASHBOARD;
export const ROUTE_REDIRECT_AFTER_LOGIN = ROUTES.DASHBOARD;
export const ROUTE_REDIRECT_FROM_UNAUTHED_ROUTE = ROUTES.DASHBOARD;
export const ROUTE_REDIRECT_FROM_AUTHED_ROUTE = ROUTES.HOME;

export const videoTypes = [
    { label: 'Product Demonstration', value: 'demonstration' },
    { label: 'Product In Use', value: 'in_use' },
    { label: 'Training', value: 'training' }
];

export const userRoleName = (id) => {
    switch (id) {
        case 0:
            return 'All';
        case 1: case 'super-admin':
            return 'Super Admin';
        case 2: case 'admin':
            return 'Admin';
        case 3: case 'pdm':
            return 'PDM';
        case 4: case 'ot-user':
            return 'Ot. User';
        case 5: case 'end-user':
            return 'End User';
        case 6: case 'technical-user':
            return 'Technical User';
        default:
            return 'Not defined';
    }
};

export const subBrandOptions = [
    { label: 'Prism', value: 'Prism' },
    { label: 'Mackworth', value: 'Mackworth' },
    { label: 'Freeway', value: 'Freeway' }
];

export const ROUTE_MATCH_REPLACER = '_REPLACE_';

export const ROUTES_WITH_PUBLIC = [
    ROUTES.HOME,
    ROUTES.SELECTED_ROOM(ROUTE_MATCH_REPLACER),
    ROUTES.CATEGORY_DETAILS(ROUTE_MATCH_REPLACER),
    ROUTES.SEARCH(ROUTE_MATCH_REPLACER),
    ROUTES.TAG(ROUTE_MATCH_REPLACER),
    ROUTES.PUBLICPRODUCT(ROUTE_MATCH_REPLACER),
    ROUTES.CONFIGURATION(ROUTE_MATCH_REPLACER),
    ROUTES.VARIATION(ROUTE_MATCH_REPLACER)
];

export async function Fetch({ body, api, token, type }) {
    const Header = {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    };

    if (token) Header.Authorization = 'Bearer ' + localStorage.getItem(STORAGEKEY_AUTH_TOKEN);

    return fetch(api, {
        headers: Header,
        method: type,
        body: body ? JSON.stringify(body) : null
    })
        .then(async response => {
            if (response.status < 200 || response.status > 299) {
                const err = await response.json();

                throw err.message;
            } else {
                const text = await response.text();

                if (text === '') {
                    return 'ResponseWithNoBody';
                }

                const data = JSON.parse(text);

                if (data && data.error) {
                    throw await data.error;
                }

                // eslint-disable-next-line no-return-await
                return await data;
            }
        })
        .then(json => json);
}

/****
 *
 * Project config
 *
 */

export const WordPressAddress = 'https://prismmedical.co.uk';
export const ConsumerKey = 'ck_860565e6ddfd1804fb6a542ad6c146cdda107e8b';
export const ConsumerSecret = 'cs_6e6a51d7e0b8603c313cf06dead5de75059d4832';
